import React from "react"
import {Box, Table, TableBody as MuiTableBody, TableHead as MuiTableHead} from "@mui/material"
import {alpha, styled} from "@mui/material/styles"

const TableRoot = styled(Table, {
    name: "ScrollableTable",
    slot: "root",
    overridesResolver: (_props, styles) => [styles.root],
})(({theme}) => ({
    minWidth: "100%",
    "& .MuiTableCell-root:not(:first-of-type)": {
        borderLeft: `1px solid ${theme.palette.divider}`,
    },
}))

export const TableHead = styled(MuiTableHead)(({theme}) => ({
    backgroundColor: `var(--table-header-bg, ${alpha(theme?.AVRIESTERTABLE?.HEADER?.backgroundColor, 0.05)})`,
    "& .MuiTableCell-root": {
        backgroundColor: "transparent",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "1.375rem",
        height: 40,
        paddingTop: 0,
        paddingBottom: 0,
    },
}))

export const TableBody = styled(MuiTableBody)({
    "& .MuiTableCell-root": {
        fontWeight: 600,
        fontSize: "14px",
        height: 32,
        paddingTop: 0,
        paddingBottom: 0,
    },
    "& .MuiTableRow-root:last-of-type .MuiTableCell-root": {
        borderBottom: "none",
    },
})

export const ScrollableTable = ({children, containerSx, noWrap, sx, ...tableProps}) => {
    let callerSx
    if (sx == null) callerSx = []
    else if (Array.isArray(sx)) callerSx = sx
    else callerSx = [sx]
    const mergedSx = noWrap
        ? [{"& .MuiTableCell-root": {whiteSpace: "nowrap"}}, ...callerSx]
        : callerSx

    return (
        <Box sx={{width: "100%", borderRadius: "8px", overflow: "hidden", ...containerSx}}>
            <Box sx={{overflowX: "auto"}}>
                <TableRoot sx={mergedSx} {...tableProps}>
                    {children}
                </TableRoot>
            </Box>
        </Box>
    )
}
